import React from "react";

function About() {
  return (
    <div>
      <h1 className="text-6xl mb-4">Github Finder</h1>
      <p className="mb-4 text-2xl font-light">
        A React app to search GitHub profiles and see profile details. The
        project code is available at
        <strong>
          <a
            href="https://github.com/swap-mitra/github-finder"
            target="_blank"
            rel="noreferrer"
          >
            {" "}
            at this repo
          </a>{" "}
        </strong>
        created by{" "}
        <strong>
          <a
            href="https://www.linkedin.com/in/swapnilmitra/"
            target="_blank"
            rel="noreferrer"
          >
            Swapnil Mitra
          </a>
        </strong>
        .
      </p>
      <p className="text-lg text-gray-400">
        Version <span className="text-white">1.0.0</span>
      </p>
    </div>
  );
}

export default About;
